import { Messages } from '../../../../../codegen/Localize';
import { IDatasourceActions } from '../../../../../datasource/ServerApi/types/IDatasourceActions';
import { IAccelerationTaskInfo } from '../../../../../ts/models/IAccelerationTaskInfo';
import { IWorkbookActions } from '../../../../../workbook/ServerApi/types/IWorkbookActions';
import { dataAccelerationTaskRunNow } from '../../../../actions/spaces/dataAcceleration/DataAccelerationTaskMenuAction';
import { selectSpaceInfoItem } from '../../../../selectors/SpaceInfoSelectors';
import { AppState } from '../../../../state/AppState';
import { currentUserIsAdmin, hasRunNowPermission } from '../../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from '../IEntityAction';

export const DataAccelerationRunNowEntityAction: IEntityAction<IAccelerationTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksRunNow,
  translateName: Messages.accelerateNow_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: dataAccelerationTaskRunNow
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IAccelerationTaskInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return currentUserIsAdmin(state) && hasRunNowPermission(state);
}
